import dayjs from 'dayjs'
import { Box } from '@mui/material'
import { Tag } from '../Tag'
import React from 'react'

import { IOrder } from '../../types/order'

interface Props {
  order: IOrder
}

const CrmTag = (props: Props) => {
  const { order } = props
  return <>
    {order.isCrm &&
      <Box py={0.5} display={'flex'} flexWrap={'wrap'} gap={1}>

        <Tag color={`error`}>
          CRM
        </Tag>

      </Box>
    }
  </>
}

export default CrmTag
